import debugT from 'debug';
import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import 'slick-carousel';
import $ from 'jquery';
import querystring from 'querystring';
import page from 'modules/ab-page-js';
import splash from './view/index.pug';
import metadata from './metadata.json';
import Animation from 'modules/animation-timeline';
import AnimationScroll from 'modules/animation-scroll';
import ContactForm from 'auth0-contact-form';
import cookieDough from 'cookie-dough';

const AB_TEST = 'cta-features-pgs';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/single-sign-on', render, loadScripts, snippets);
}

function loadScripts(ctx, next) {
  const cookie = cookieDough();
  const abExperiments = JSON.parse(cookie.get('ajs_ab.traits'));
  if (abExperiments && abExperiments[AB_TEST]) {
    window.metricsLib.track(`ab:viewed-${AB_TEST}`, {
      experiment_id: AB_TEST,
      variation_id: abExperiments[AB_TEST],
    });
  }
  next();
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  next();
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:singl-sign-on-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:singl-sign-on-contact-form', metricsData);
    },
    source: 'singl-sign-on'
  };

  /* eslint-env browser */
  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    const ttsMetadata = { place: 'banner', type: 'button', text: 'talk to sales' };
    element.addEventListener(
      'click',
      () => {
        metricsLib.track('click:contact-sales', { trackData: { ...ttsMetadata } }, () => window.location.assign(`/contact-us?${querystring.stringify(ttsMetadata)}`))
      },
      false
    );
  });
}

function slickCarousel() {
  $('.sso-slider').slick({
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 500,
    arrows: true,
    fade: true,
    dots: true,
    cssEase: 'linear'
  });
}

function snippets(ctx, next) {
  setupAnimations();
  contactFormModals();
  slickCarousel();

  next();
}

function setupAnimations() {
  const heroAnimation = setupHeroAnimation();
  // animationScroll.add({
  //   id: 'js-hero-animation-container',
  //   animation: heroAnimation,
  //   options: { offsetTop: -100, oneShot: true }
  // });

  // animationScroll.start();

  heroAnimation.run();
}

function setupHeroAnimation() {
  const $elem = $('.single-sign-on section.hero .hero-animation');
  const animation = new Animation($elem);

  return animation
    .fadeIn(500)
    .addClass('initial')
    .removeClass(
      'user-recognized sso-loading inbox second-login login-click second-sso-loading second-sso-finished'
    )
    .keyboardType('maggie@acme.com', 'data-username')
    .delay(500)
    .toggleClass('user-recognized')
    .keyboardType('●●●●●●●●', 'data-password')
    .delay(300)
    .toggleClass('initial sso-loading')
    .delay(800)
    .toggleClass('sso-loading inbox')
    .delay(1000)
    .toggleClass('second-login')
    .delay(2000)
    .toggleClass('login-click')
    .delay(800)
    .toggleClass('second-sso-loading')
    .delay(1600)
    .toggleClass('second-login second-sso-loading second-sso-finished');
}



// WEBPACK FOOTER //
// ./src/pages/single-sign-on/client.js